import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { adsense } from '../../../appRedux/actions/Adsense'

import { Button, Checkbox, Popconfirm, Form, InputNumber } from "antd";

const AdsenseSection = ({ editFormContents }) => {
    const dispatch = useDispatch();

    const [contentCount, setContentCount] = useState([]);
    const [contentData, setContentData] = useState({ sortNo: [], isAdsense: [] });

    useEffect(() => {

        editFormContents.map((item, i) => {
            contentCount.push("");
            const updateContentCount = [...contentCount];
            setContentCount(updateContentCount);

            _renderContentSection(i);

            let initContent = { ...contentData };
            initContent.sortNo[i] = item.sort;
            initContent.isAdsense[i] = item.adsense;

            setContentData(initContent);

            // for initial value set in redex store
            dispatch(adsense(initContent));
        })
    }, [editFormContents?.length]);

    const _renderContentSection = (i) => {

        const addSortNo = (value) => {
            console.log(value, i);
            let sortList = { ...contentData };
            sortList.sortNo[i] = value;
            sortList.isAdsense[i] = false;
            setContentData(sortList);
            console.log(contentData);

            dispatch(adsense(sortList));
        };

        const addIsAdsense = (e) => {

            console.log(e.target.checked, i);
            let isAdsenseList = { ...contentData };
            isAdsenseList.isAdsense[i] = e.target.checked;
            setContentData(isAdsenseList);
            dispatch(adsense(isAdsenseList));
        };

        return (
            <div className="ant-row" key={"Ad_" + i}>
                <div className="ant-col-md-8">
                    <InputNumber
                        required
                        placeholder="Sort No"
                        onChange={addSortNo}
                        value={contentData.sortNo[i]}
                    />
                    <a href="" title="Delete">
                        <Popconfirm
                            title="Are you sure delete this ?"
                            onConfirm={async () => {
                                contentCount.splice(i, 1);
                                contentData.sortNo.splice(i, 1);
                                contentData.isAdsense.splice(i, 1);

                                setContentData(contentData);

                                const updateContentCount = [...contentCount];
                                setContentCount(updateContentCount);
                            }}
                            onCancel={() => { }}
                            okText="Yes"
                            cancelText="No"
                        >
                            <span className="gx-link" title="Delete">
                                <i className="icon icon-trash"></i>
                            </span>
                        </Popconfirm>
                    </a>
                </div >
            </div>
        );
    }

    return (
        <div>
            <div className="ant-row hd-title gx-m-0">
                <div className="ant-col-md-12">
                    <h1>Manage Adsense</h1>
                </div>
                <div className="ant-col-md-12 rite-btn">
                    <Button
                        type="primary"
                        className="color-white"
                        onClick={() => {
                            contentCount.push("");
                            const updateContentCount = [...contentCount];
                            setContentCount(updateContentCount);
                        }}
                    >
                        <i class="icon icon-add"></i> Add
                    </Button>
                </div>
            </div>

            {
                contentCount?.map((item, index) => {
                    return _renderContentSection(index);
                })
            }
        </div>

    );
}

export default Form.create()(AdsenseSection);